import { render } from "./PageNotFound.vue?vue&type=template&id=08f9b330"
const script = {}

import exportComponent from "/vercel/path0/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__